<div class="rollover-footer-wrapper">
  <div class="rollover-footer">
    <div class="rollover-footer__header">
      <div class="rollover-footer__title" [innerHTML]="content.title"></div>

      <div class="rollover-footer__divider"></div>
    </div>

    <div class="rollover-footer__button">
      <button
        auraLink
        [linkSize]="'large'"
        [linkColor]="'primary'"
        [id]="getActionDetail(open, content.actions).id"
        (click)="open = !open"
        class="rollover-footer__button-action"
      >
        {{ getActionDetail(open, content.actions).label }}
      </button>
    </div>

    <div
      class="rollover-footer__faq-panel"
      *ngFor="let enquiry of content.enquiry; let i = index"
    >
      <div class="rollover-footer__secondary-divider">
        <aura-divider [type]="'light'"></aura-divider>
      </div>
      <aura-expansion-panel
        [expanded]="open"
        [border]="'none'"
        [arrowColor]="'red'"
        [position]="'none'"
        [arrowPosition]="'right'"
        [stylesArray]="expanderStyle"
        auraCustomStyles
        class="rollover-footer__panel"
      >
        <div
          header
          class="rollover-footer__header-container"
          [innerHTML]="enquiry.title"
          [id]="'faq_' + i"
        ></div>
        <div
          body
          class="rollover-footer__header-container"
          [innerHTML]="enquiry.subtitle"
        ></div>
      </aura-expansion-panel>
    </div>

    <div class="rollover-footer__terms-and-condition-panel">
      <div class="rollover-footer__secondary-divider">
        <aura-divider [type]="'dark'"></aura-divider>
      </div>
      <aura-expansion-panel
        [border]="'none'"
        [arrowColor]="'red'"
        [stylesArray]="termsConditionsStyle"
        auraCustomStyles
        [position]="'none'"
      >
        <div
          header
          class="rollover-footer__terms-and-condition-panel-header"
          id="termsAndCondition"
        >
          <div class="footer-title">
            {{ content.stipulation.title }}
          </div>
        </div>
        <div
          body
          class="rollover-footer__terms-and-condition-panel-body"
          [innerHTML]="content.stipulation.subtitle"
        ></div>
      </aura-expansion-panel>
    </div>
  </div>
</div>
